<template>
  <div class="result-root relative w-full flex flex-col">
    <div class="flex-1 relative" :style="containerStyle">
      <model-viewer
        class="h-full"
        bg-white
        :shader-type="shaderType"
        :custom-shader="customShader"
        :obj-url="objUrl"
        :measurement="currentMeasurement"
      />
      <unit-switcher
        v-show="hasMeasurements"
        class="absolute top-0 left-0 right-0 mx-auto mt-10"
        :layout="'dark'"
        :use-inch="useInch"
        @toggle="onUnitSwitch"
      />
      <!-- Left -->
      <measurement-bar
        v-if="leftMeasurements[0]"
        :layout="'dark'"
        :measurements="leftMeasurements"
        :active-index="activeMeasurementIndex"
        :use-inch="useInch"
        @click="onMeasurementClick"
      />
      <!-- Right -->
      <measurement-bar
        v-if="rightMeasurements[0]"
        right
        :layout="'dark'"
        :measurements="rightMeasurements"
        :active-index="activeMeasurementIndex - 5"
        :use-inch="useInch"
        @click="onMeasurementClick($event + 5)"
      />
    </div>
    <panel :relative="!measurementFailed" :height="panelHeight" dark>
      <div class="w-full text-center">
        <error v-if="measurementFailed" />
        <template v-if="!nothingYet">
          <h3
            v-if="!measurementFailed"
            class="scan-result-message mt-3 font-bold"
            v-html="$t('stamp.scan_successful')"
          ></h3>
          <div
            v-if="showDoll"
            class="mini-doll flex my-5 justify-center bg-black lg:mt-20 lg:-mb-16"
            :class="{ 'mt-16': hasMeasurements }"
          >
            <doll
              :left="left"
              :right="right"
              :left-range="leftRange"
              :right-range="rightRange"
              :bubble-actions="actions"
              mini
              left-breathing
              right-breathing
              @left-click="handleLeftClick"
              @right-click="handleRightClick"
              @left-hit="handleLeftHit"
              @right-hit="handleRightHit"
            />
          </div>
        </template>
        <p v-else class="text-2xl mt-10 text-white font-bold">{{ $t('stamp.analyzing') }}</p>
      </div>
    </panel>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import i18n from '../../i18n';
import audioPlayer from '../../mixins/audio-player';
import scanResults from '../../mixins/scan-results';

import MeasurementBar from '../../components/ShowResult/MeasurementBar.vue';
import ModelViewer from '../../components/common/ModelViewer.vue';
import Panel from '../../components/common/Panel.vue';
import UnitSwitcher from '../../components/common/UnitSwitcher.vue';
import Doll from '../../components/Stamp/Doll.vue';
import Error from '../../components/Stamp/Error.vue';

export default {
  name: 'ShowResult',
  components: {
    MeasurementBar,
    Panel,
    ModelViewer,
    Error,
    Doll,
    UnitSwitcher,
  },
  mixins: [audioPlayer, scanResults],
  computed: {
    ...mapState('mtmUser', ['shaderType', 'customShader']),
    leftMeasurements() {
      return this.measurements.slice(0, 5).map(m => ({
        ...m,
        name: i18n.t(`stamp.${m.nameKey || (this.isFemale ? 'chest_female' : 'chest')}`),
      }));
    },
    rightMeasurements() {
      return this.measurements
        .slice(5, 10)
        .map(m => ({ ...m, name: i18n.t(`stamp.${m.nameKey}`) }));
    },
    actions() {
      return this.measurementFailed
        ? [i18n.t('stamp.leave'), i18n.t('stamp.scan_again')]
        : [i18n.t('stamp.scan_again'), i18n.t('stamp.end_next')];
    },
  },
  watch: {
    hasMeasurements(nv) {
      if (nv) {
        this.playAudio('Voice8');
      }
    },
    measurementFailed(nv, ov) {
      if (nv && !ov) {
        this.playAudio('40');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.result-root {
  background-color: white;
}
.scan-result-message {
  font-size: 25px;
  color: white;
}
.mini-doll {
  max-height: 200px;
  overflow: visible;
}
</style>
